import React, { useState, useEffect } from "react";
import {
  ActionIcon,
  Badge,
  Button,
  Modal,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import TablePagination from "../componenets/Common/TablePagination";
import UniversalTable from "../componenets/Common/UniversalTable";
import {
  IconEye,
  IconInfoCircle,
  IconSortAscending,
  IconSortDescending,
} from "@tabler/icons-react";
import { IconHistory } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ObligationTranHistoryModal from "./ObligationTranHistoryModal";
import {
  departmentData,
  excelDownload,
  formatDatetoISO,
  getComplianceBadgeColor,
  getDepartmentText,
  getStatusColor,
  getStatusText,
  infoColor,
  infoColorTable,
} from "./utilities";
import lexend from "./Lexend-Black.ttf";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../redux/authSlice";
import { getActionedObligations, getTitlesApi } from "../apis/obligationApi";
import { fetchBuOptions } from "../apis/userApis";
import { DatePicker } from "@mantine/dates";
import { getCookiesSession } from "../apis/cookiesSession";

const ActionedObligations = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = JSON.parse(getCookiesSession("userData"));
  const businessUnit = userData.businessUnit;
  const department = userData.activeDepartment;
  const role = userData.loginAs;
  const [ahModal, setAhModal] = useState(false);
  const [ahId, setAhId] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [configs, setConfigs] = useState({
    loading: true,
    obligations: [],
    count: 0,
  });
  const [reload, setReload] = useState(true);
  const [filters, setFilters] = useState({
    joOrder: null,
    department: null,
    businessUnit: null,
    compliant: null,
    title: null,
  });
  const [page, setPage] = useState(1);
  const [buData, setBuData] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);
  const [csvData, setCsvData] = useState([]);
  useEffect(() => {
    const getBuData = async () => {
      const response = await fetchBuOptions();
      setBuData(response.buData);
    };
    getBuData();
    const getTitles = async () => {
      const response = await getTitlesApi();
      if (response.success) {
        setTitleOptions(response.titles);
      }
    };
    getTitles();
  }, []);

  const [sortByOptions, setSortByOptions] = useState({
    key: "duedate",
    value: "asc",
  });
  const handleKeyChange = (val) => {
    const newSortOption = { key: val, value: sortByOptions.value };
    setSortByOptions(newSortOption);
  };
  const toggleOrder = () => {
    const newSortOption = {
      key: sortByOptions.key,
      value: sortByOptions.value === "asc" ? "desc" : "asc",
    };
    setSortByOptions(newSortOption);
  };

  useEffect(() => {
    const getObligations = async () => {
      const filterdata = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => value !== null)
      );
      const sortOption = { [sortByOptions.key]: sortByOptions.value };
      const response = await getActionedObligations({
        filters: filterdata,
        page: page,
        pageSize,
        sortByOptions: sortOption,
      });
      setCsvData(response.exportData);
      console.log(response.obligations);
      setConfigs({
        loading: false,
        obligations: response.obligations,
        count: response.count,
      });
    };
    getObligations();
  }, [page, pageSize, reload, sortByOptions]);
  const onExport = async () => {
    if (csvData.length > 0) {
      const columnHeaders = Object.keys(csvData[0]);
      excelDownload({
        data: csvData,
        headers: columnHeaders,
        name: "actioned_obligations",
      });
    }
  };
  const onViewClick = (id) => {
  window.open(`/viewobligation/${id}`, '_blank');
};
  return (
    <div style={{ fontFamily: lexend }}>
      <Text className="flex justify-center font-bold text-xl my-4">
        actioned obligations
      </Text>
      <div className="flex grid grid-cols-6 gap-4">
        <Select
          searchable
          label="department"
          placeholder="department"
          value={filters.department}
          data={departmentData}
          onChange={(val) => {
            setFilters({ ...filters, department: val });
          }}
        />
        <Select
          label="compliance"
          placeholder="compliance"
          value={filters.compliant}
          onChange={(val) => setFilters({ ...filters, compliant: val })}
          data={[
            { label: "upcoming", value: "upcoming" },
            {label: "due", value: "due"},
            { label: "non-compliant", value: "non-compliant" },
            
            {
              label: "partially-compliant",
              value: "partially-compliant",
            },
            { label: "compliant", value: "compliant" },
            {
              label: "delayed-compliant",
              value: "delayed-compliant",
            },
          ]}
        />
        <Select
          label="business unit"
          placeholder="business unit"
          value={filters.businessUnit}
          data={buData}
          onChange={(val) => setFilters({ ...filters, businessUnit: val })}
        />
        <TextInput
          label="job order"
          placeholder="enter job order"
          value={filters.joOrder ? filters.joOrder?.contains : ""}
          onChange={(e) =>
            setFilters({ ...filters, joOrder: { contains: e.target.value } })
          }
        />
        <Select
          searchable
          label="obligation title"
          placeholder="obligation title"
          data={titleOptions}
          value={filters.title}
          onChange={(val) => setFilters({ ...filters, title: val })}
        />
        <Select
          label="status"
          data={[
            { label: "upcoming", value: 0 },
            { label: "due", value: 1 },
            { label: "overdue", value: 2 },
          ]}
          styles={{
            width: "120px",
            placeholder: {
              fontSize: "10px", // Customize placeholder size
              color: "#999", // Optional: Change placeholder color
            },
          }}
          placeholder="status"
          onChange={(val) => {
            if (val === 0) {
              setFilters({
                ...filters,
                reminderDate: {
                  gt: new Date(), // new Date() < reminderDate
                },
              });
            } else if (val === 1) {
              setFilters({
                ...filters,
                duedate: {
                  gt: new Date(), // dueDate > new Date()
                },
                reminderDate: {
                  lt: new Date(), // new Date() > reminderDate
                },
              });
            } else if (val === 2) {
              setFilters({
                ...filters,
                duedate: {
                  lt: new Date(), // new Date() > dueDate
                },
              });
            }
          }}
        />
        <DatePicker
          label="due date start from"
          placeholder="start from"
          value={filters?.duedate?.gt}
          onChange={(val) =>
            setFilters({
              ...filters,
              duedate: { ...filters.duedate, gte: val },
            })
          }
        />
        <DatePicker
          label="due date till"
          placeholder="range end date"
          value={filters.duedate?.lte}
          onChange={(val) =>
            setFilters({
              ...filters,
              duedate: { ...filters.duedate, lte: val },
            })
          }
        />
      </div>
      <div className="mt-4 flex gap-8">
        <Button
          color="#1b6f8d"
          onClick={() => {
            window.location.reload();
          }}
        >
          Clear
        </Button>
        <Button variant="outline" onClick={() => setReload(!reload)}>
          Search
        </Button>
      </div>
      <div className="flex justify-end">
        <div className="flex">
          <Select
            value={sortByOptions.key}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "start date", value: "startDate" },
              { label: "due date", value: "duedate" },
              { label: "second party", value: "connectedParty" },
              { label: "id", value: "id" },
              { label: "brand name", value: "brandName" },
              { label: "title", value: "title" },
            ]}
          />

          <ActionIcon className="mx-2" onClick={toggleOrder}>
            {sortByOptions.value === "asc" ? (
              <IconSortAscending size={32} />
            ) : (
              <IconSortDescending size={32} />
            )}
          </ActionIcon>
        </div>
        <Button onClick={onExport}>Export</Button>
      </div>
<>
          <UniversalTable
            headers={[
              {
                label: "obligation id",
                align: "center",
                render: (row) => <Text size="sm">{row.id}</Text>,
              },
              {
                label: "obligation title",
                align: "center",
                render: (row) => <Text size="sm" weight={600}>{row.title}</Text>,
              },
              {
                label: "second party",
                align: "center",
                render: (row) => (
                  <div>
                    <Text size="sm">{row.brandName}</Text>
                    <Text size="xs" c="dimmed">{"( " + row.connectedParty + " )"}</Text>
                  </div>
                ),
              },
              {
                label: "job order",
                align: "center",
                render: (row) => <Text size="sm">{row.joOrder || "--"}</Text>,
              },
              {
                label: "department",
                align: "center",
                render: (row) => <Text size="sm">{getDepartmentText(row.department)}</Text>,
              },
              {
                label: "compliance",
                align: "center",
                render: (row) => (
                  <Badge
                    variant="light"
                    radius="xl"
                    size="sm"
                    color={getComplianceBadgeColor(row.compliant)}
                  >
                    {row.compliant}
                  </Badge>
                ),
              },
              {
                label: "due date",
                align: "center",
                render: (row) => <Text size="sm">{formatDatetoISO(row.duedate)}</Text>,
              },
              {
                label: "actions",
                align: "center",
                render: (row) => (
                  <div className="flex flex-row justify-center gap-1">
                    <ActionIcon
                      onClick={() => onViewClick(row.id)}
                      variant="subtle"
                      color="#1b6f8d"
                      radius="md"
                    >
                      <IconEye size={18} stroke={1.5} color="#1b6f8d" />
                    </ActionIcon>
                    <ActionIcon
                      onClick={() => {
                        setAhId(row.id);
                        setAhModal(true);
                      }}
                      variant="subtle"
                      color="gray"
                      radius="md"
                    >
                      <IconHistory size={18} stroke={1.5} />
                    </ActionIcon>
                    {row.extraCol3 !== "" && (
                      <ActionIcon variant="subtle" radius="md">
                        <IconInfoCircle
                          color={infoColor(row.extraCol3)}
                          size={18}
                          stroke={1.5}
                        />
                      </ActionIcon>
                    )}
                  </div>
                ),
              },
            ]}
            data={configs.obligations}
            loading={configs.loading}
          />
          <TablePagination
            totalCount={configs.count}
            page={page}
            pageSize={pageSize}
            dataLength={configs.obligations?.length || 0}
            onPageChange={(val) => setPage(val)}
            onPageSizeChange={(val) => {
              setPageSize(val);
              setPage(1);
            }}
          />
        </>
      <Modal
        opened={ahModal}
        onClose={() => {
          setAhModal(false);
          setAhId(0);
        }}
        title="oblligation action history"
        size="calc(80vw)"
      >
        <ObligationTranHistoryModal id={ahId} />
      </Modal>
    </div>
  );
};

export default ActionedObligations;
